module.exports = __webpack_public_path__ + "static/item--ac--f6@3x.b15f2503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f6@3x.png
// module id = 624
// module chunks = 126511778744290